import { Modal } from 'antd';

type RemoveAlwaysIncludedModalProps = {
  open: boolean;
  onChange?: (value: boolean) => void;
  onCancel: () => void;
};

export const RemoveAlwaysIncludedModal = ({
  open,
  onCancel,
  onChange,
}: RemoveAlwaysIncludedModalProps) => {
  const handleConfirmRemove = () => {
    onChange?.(false);
    onCancel();
  };

  return (
    <Modal
      title={`Remove Experience from section "Always included overnight"`}
      open={open}
      onCancel={onCancel}
      onOk={handleConfirmRemove}
      okText="I understand"
      cancelText="Cancel"
      destroyOnClose
    >
      This experience will not be attached to any packages anymore.{' '}
      <strong>Manually add</strong> this experience to all relevant packages.
    </Modal>
  );
};
